import { FormattedMessage } from 'react-intl'

import { Form } from '@subaio/components/src/HookForm'
import { mapLocaleOptions } from '@subaio/webapp'

import { ButtonGroup, ButtonSelect, ButtonSolidSubmit } from 'components/Buttons'
import { IconWarning } from 'components/Icons'
import { InfoBox } from 'components/InfoBox'
import { Card, ConstrainedContent } from 'components/Layout'

type Props = {
	locale: string
	localeOptions: Array<string>
	hasInvalidLogin: boolean
	hasUnknownError: boolean

	onSubmit: () => Awaitable<void>
	setLocale: (locale: string) => void
}

export const OneTimeAuthenticationForm = ({
	onSubmit,
	hasInvalidLogin,
	hasUnknownError,
	locale,
	localeOptions,
	setLocale,
}: Props) => (
	<Card
		title={
			<FormattedMessage id='oneTimeAuthentication.subtitle' defaultMessage='Please select your language to continue' />
		}
	>
		<Form<Record<string, never>>
			render={() => (
				<>
					<ConstrainedContent>
						<ButtonSelect
							label={<FormattedMessage id='oneTimeAuthentication.labelLanguage' defaultMessage='Select language' />}
							options={mapLocaleOptions(localeOptions, { shortName: true })}
							selectedValue={locale}
							typeOfOptions='locale'
							onSelect={(value) => setLocale(value)}
						/>
						{hasInvalidLogin && (
							<InfoBox type='danger'>
								<div>
									<IconWarning />
									<h2>
										<FormattedMessage id='oneTimeAuthentication.invalidTitle' defaultMessage='The link is invalid' />
									</h2>
								</div>
								<div>
									<FormattedMessage
										id='oneTimeAuthentication.invalid'
										defaultMessage='If the issue persists, reach out to your advisor.'
									/>
								</div>
							</InfoBox>
						)}
						{hasUnknownError && (
							<InfoBox type='danger'>
								<div>
									<IconWarning />
									<h2>
										<FormattedMessage
											id='oneTimeAuthentication.unknownErrorTitle'
											defaultMessage='An unknown error occurred'
										/>
									</h2>
								</div>
								<div>
									<FormattedMessage
										id='oneTimeAuthentication.invalid'
										defaultMessage='If the issue persists, reach out to your advisor.'
									/>
								</div>
							</InfoBox>
						)}
						<p>
							<FormattedMessage
								id='oneTimeAuthentication.description'
								defaultMessage='Thank you for helping us understand your finances.'
							/>
						</p>
						<p>
							<FormattedMessage
								id='oneTimeAuthentication.description2'
								defaultMessage='It typically takes 5-10 minutes to complete the process.'
							/>
						</p>
					</ConstrainedContent>
					<ButtonGroup>
						<ButtonSolidSubmit
							label={<FormattedMessage id='oneTimeAuthentication.buttonSubmit' defaultMessage='Start' />}
						/>
					</ButtonGroup>
				</>
			)}
			onSubmit={onSubmit}
		/>
	</Card>
)
